import React from 'react'
import { tints } from '@manychat/manyui'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

interface TooltipProps {
  text: string
}

const DEFAULT_WIDTH_PX = 354
const DEFAULT_PADDING_PX = 12
const DEFAULT_MARGIN_PX = 16

const TextStyles = {
  ...sharedStyles.text,
  fontSize: '18px',
  color: tints.neutral[7],
  lineHeight: 1.2,
}

const WrapperStyles: React.CSSProperties = {
  background: tints.neutral[1],
  borderRadius: 4,
  display: 'flex',
  opacity: 0.88,
  padding: DEFAULT_PADDING_PX,
  position: 'absolute',
  right: -DEFAULT_WIDTH_PX - DEFAULT_MARGIN_PX,
  top: -DEFAULT_PADDING_PX,
  width: DEFAULT_WIDTH_PX,
  wordWrap: 'break-word',
}

export const Tooltip = ({ text }: TooltipProps) => {
  return (
    <view style={WrapperStyles}>
      <richtext text={text} style={TextStyles} />
    </view>
  )
}
